var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "create-incident"
  }, [_c('ul', {
    attrs: {
      "role": "menu"
    }
  }, _vm._l((this.dataTree), function(item) {
    return _c('li', {
      key: item.id,
      class: {
        'has-nested-menu': item.children.length > 0
      }
    }, [(item.children.length > 0) ? _c('a', {
      attrs: {
        "href": "#"
      }
    }, [(item.ismenu == true) ? _c('span', {
      staticClass: "caret",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', {
      staticClass: "caret",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(item.name))])]) : _c('a', {
      attrs: {
        "href": "#"
      }
    }, [(item.ismenu == true) ? _c('span', {
      staticClass: "caret",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', {
      staticClass: "caret",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.children.length > 0) ? _c('CategoryTree', {
      attrs: {
        "dataTree": item.children
      }
    }) : _vm._e()], 1)
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dafa3ee4","hasScoped":true}!./src/views/components/CategoryTree/CategoryTree.component.html
// module id = 878
// module chunks = 1